<script setup lang="ts">
defineProps({
	rows: {
		type: [Number, String],
		default: 1,
	},
	space: {
		type: String,
		default: '16',
	},
	hasDivider: {
		type: Boolean,
		default: false,
	},
	isRowDirection: {
		type: Boolean,
		default: false,
	},
});
</script>

<template>
	<div
		:class="['skeleton-group', { '--row-direction': isRowDirection }]"
		:style="space ? { gap: `${space}px` } : {}"
	>
		<div
			v-for="(_item, index) in Number(rows)"
			:key="index"
			class="skeleton-item"
		>
			<slot />
			<VDivider v-if="hasDivider && index !== Number(rows) - 1" />
		</div>
	</div>
</template>

<style scoped lang="scss">
.skeleton-group {
	display: flex;
	flex-direction: column;

	&.--row-direction {
		flex-direction: row;
	}

	.skeleton-item {
		margin: 0;
		padding: 0;
	}
}
</style>
